<template>
  <div 
    ref="dropdownRef" 
    class="dropdown"
    aria-haspopup="true"
    :class="{
      'dropdown--right': props.position === 'right',
      'dropdown--center': props.position === 'center',
      'dropdown--open': isOpen,
    }"
    :aria-expanded="isOpen ? 'true' : 'false'">
    <AppButton v-bind="$attrs" @click="isOpen = !isOpen">
      <slot name="trigger"></slot>
    </AppButton>

    <transition name="fade">
      <div v-if="isOpen" class="dropdown__dialog" ref="dropdownContent" @click="onClick">
        <div class="dropdown__content">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>
<script lang="ts" setup>
import AppButton from "@/components/app-button.vue";
import { onClickOutside } from '@vueuse/core';
import { ref } from "vue";

const props = defineProps<{
  position?: "right" | "center",
}>();

const dropdownRef = ref<HTMLElement>();
const isOpen = ref(false);

onClickOutside(dropdownRef, (event) => {
  if (isOpen.value) {
    close();
  }
});

const onClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (target.closest('a, button')) {
    close();
  }
};

const close = () => {
  isOpen.value = false;
};

</script>
<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
